﻿var landPortfolio = (function () {
    return {
        init: function ($el) {
            $el.on('change', function () {
                window.location.href = this.value;
            });
        }
    };
})();
$(document).ready(function () {
    // only init if the control is on this page
    if ($('#landFilter').length > 0) {
        landPortfolio.init($('#landFilter'));
    }
});